import {Chip} from 'platform/components';
import {HStack, Stack, Text} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

interface SellerTypeOption {
  value: string;
  label: string;
}

interface SellerTypePropertyChipsProps {
  label: string;
  /** null / empty = any */
  value: string[] | null;
  onChange: (next: string[] | null) => void;
  options: SellerTypeOption[];
  isReadOnly?: boolean;
}

function toggleSellerType(current: string[] | null, key: string): string[] | null {
  const selected = current ?? [];
  const next = selected.includes(key)
    ? selected.filter((item) => item !== key)
    : [...selected, key];

  return next.length === 0 ? null : next;
}

export function SellerTypePropertyChips(props: SellerTypePropertyChipsProps) {
  const selected = props.value ?? [];
  const isAnySelected = isNilOrEmpty(selected);

  return (
    <Stack
      direction={['column', 'row']}
      align={[undefined, 'center']}
      justify="space-between"
      spacing={2}
    >
      <Text size="small">{props.label}</Text>
      <HStack spacing={1}>
        {props.options.map((option) => (
          <Chip
            key={option.value}
            label={option.label}
            value={selected.includes(option.value)}
            onChange={() => props.onChange(toggleSellerType(props.value, option.value))}
            size="small"
            isDisabled={props.isReadOnly}
          />
        ))}
        <Chip
          label={i18n.t('entity.sourcing.relativeFilters.mode.any')}
          value={isAnySelected}
          onChange={() => props.onChange(null)}
          size="small"
          isDisabled={props.isReadOnly}
        />
      </HStack>
    </Stack>
  );
}
